import React, {useState, useEffect} from 'react'
import {MDBAlert, MDBBtn, MDBCard, MDBCardBody, MDBListGroupItem} from "mdbreact";
import AsyncSelect from 'react-select/async';

import classes from './SchoolEmailVerification.module.css'
import {isSchoolEmail, isValidEmail} from "../../Utils/converter";

const schoolEmailValidator = (email) => {
    if (isValidEmail(email) && email !== '') {
        if (isSchoolEmail(email)) {
            return ({
                isValidEmail: true,
                isSchoolEmail: true
            })
        } else {
            return ({
                isValidEmail: true,
                isSchoolEmail: false
            })
        }
    } else {
        return ({
            isValidEmail: false,
            isSchoolEmail: false
        })
    }
}


const checkEmailIsExist = (email) => {
    return new Promise(async (resolve, reject) => {
        await fetch("/api/member/isExist", {
            method: 'POST',
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({
                email: email
            })
        }).then((res) => res.json()).then((finalResponse) => {
            resolve(finalResponse)
        })
    })
}

const submitEmailRequest = (schoolEmail, type, uid, schoolID) => {
    return new Promise(async (resolve, reject) => {
        const getState = await checkEmailIsExist(schoolEmail)
        if (!getState.isExist) {

            await fetch("/api/member/submitAuthRequest", {
                method: 'POST',
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    uid: uid,
                    schoolID: schoolID,
                    email: schoolEmail,
                    type: type
                })
            }).then((res) => res.json()).then((finalResponse) => {
                resolve({
                    success: true,
                    isSent: true
                })
            })
        } else {
            resolve({
                success: true,
                isExist: true
            })
        }
    })

}

const startToSearch = async (searchStr) => {
    return await new Promise((resolve, reject) => {
        fetch("/api/search/community", {
            method: 'POST',
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({
                searchStr: searchStr
            })
        }).then((res) => res.json()).then((searchResult) => {
            let newArr = []
            if (searchResult.length !== 0) {
                searchResult.map((s, index) => {
                    newArr.push({
                        label: s.titleCHI + ' / ' + s.title,
                        value: s.objectID
                    })
                })
                return resolve(newArr)
            } else {
                return resolve(newArr)
            }
        })
    })
}


const SchoolEmailVerification = (props) => {

    const [schoolEmail, setSchoolEmail] = useState("")
    const [isSchoolEmail, setIsSchoolEmail] = useState(false)
    const [isValidEmail, setIsValidEmail] = useState(false)
    const [selectedSchool, setSelectedSchool] = useState({})
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [emailExist, setEmailExist] = useState(false)
    const [isSent, setIsSent] = useState(false)

    return (
        <div>
            <MDBCard className={classes.EmailValidor}>
                <MDBCardBody>
                    你是學校的老師或學生嗎？ 在下方輸入學校的電子郵件進行驗證。
                    <label className={classes.label}>
                        你的學校
                    </label>
                    <div className={classes.SearchInput}>
                        <AsyncSelect
                            cacheOptions
                            loadOptions={startToSearch}
                            defaultOptions
                            isDisabled={isSubmitting}
                            onChange={(e) => setSelectedSchool(e)}
                        />
                    </div>

                    {
                        typeof selectedSchool.label !== 'undefined' ?
                            <p>你已經選擇: {selectedSchool.label}</p>
                            : <p>搜尋你的學校</p>
                    }


                    <label className={classes.label}>
                        學校的電子郵件
                    </label>
                    <span className={classes.SchoolEmail}>示範電子郵件: s11111111@abcd.edu.hk</span>
                    <input
                        type="text"
                        className={["form-control", classes.EmailInput].join(' ')}
                        onChange={(e) => {
                            setEmailExist(false)
                            setSchoolEmail(e.target.value)
                            const res = schoolEmailValidator(e.target.value)
                            setIsSchoolEmail(res.isSchoolEmail)
                            setIsValidEmail(res.isValidEmail)
                        }}
                        disabled={isSubmitting}
                        value={schoolEmail}
                        placeholder={"學校電子郵件"}
                    />
                    {
                        schoolEmail !== '' && isValidEmail && isSchoolEmail && !isSubmitting && typeof selectedSchool.label !== 'undefined' && selectedSchool.label !== '' ?
                            <MDBAlert color='success' className={classes.EmailCheckResult}>
                                此電子郵件可用按下進行驗證
                                <MDBBtn color='success'
                                        onClick={async () => {
                                            setIsSubmitting(true)
                                            const submitState = await submitEmailRequest(schoolEmail, schoolEmail.split('@')[0].length > 6 ? 'STUDENT' : 'TEACHER', props.auth.uid, selectedSchool.value)
                                            if (submitState.success) {
                                                if (submitState.isExist) {
                                                    setEmailExist(true)
                                                    setIsSubmitting(false)
                                                }
                                                if (submitState.isSent) {
                                                    setIsSent(true)
                                                }
                                            }
                                        }}>
                                    進行驗證
                                </MDBBtn>
                            </MDBAlert> : ''
                    }
                    {
                        schoolEmail !== '' && !isSchoolEmail && isValidEmail && !isSubmitting && typeof selectedSchool.label !== 'undefined' && selectedSchool.label !== '' ?
                            <MDBAlert color='warning' className={classes.EmailCheckResult}>
                                此電子郵件不是學校電子郵件
                                <MDBBtn color='warning'
                                        onClick={async () => {
                                            setIsSubmitting(true)
                                            const submitState = await submitEmailRequest(schoolEmail, 'PENDING', props.auth.uid, selectedSchool.value)
                                            if (submitState.success) {
                                                if (submitState.isExist) {
                                                    setEmailExist(true)
                                                    setIsSubmitting(false)
                                                }
                                                if (submitState.isSent) {
                                                    setIsSent(true)
                                                }
                                            }
                                        }}
                                >
                                    進行人工驗證
                                </MDBBtn>
                            </MDBAlert> : ''
                    }
                    {
                        schoolEmail !== '' && !isSchoolEmail && !isValidEmail ?
                            <MDBAlert color='danger' className={classes.EmailCheckResult}>
                                此電子郵件無效
                            </MDBAlert> : ''
                    }

                    {
                        isSubmitting ?
                            emailExist ?
                                <MDBAlert color='danger' className={classes.EmailCheckResult}>
                                    此電子郵件已經注冊
                                </MDBAlert> :
                                isSent ?
                                    <MDBAlert color='success' className={classes.EmailCheckResult}>
                                        已發送電子郵件，請按下郵件連結完成注冊。
                                        郵件有機會被視為垃圾郵件
                                    </MDBAlert> :
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                            : ''
                    }

                </MDBCardBody>

            </MDBCard>
        </div>
    )
}
export default SchoolEmailVerification